import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {OriginalUserInterface} from "@/api/Partners/LoginAs/Interfaces/OriginalUserInterface";
import {OriginalUserStorageService} from "@/features/Auth/LoginAs/Services/OriginalUserStorageService";
import {LoginAsPartnerApiSlice} from "@/api/Partners/LoginAs/LoginAsPartnerApiSlice";
import {RootState} from "@/store/Store";

interface LoginAsState {
    originalUser: OriginalUserInterface | null,
}

function getInitialState(): LoginAsState {
    const service = new OriginalUserStorageService();
    return {
        originalUser: service.getFromStorage(),
    };
}

export const LoginAsSlice = createSlice({
    name: "LoginAsSlice",
    initialState: getInitialState(),
    reducers: {
        setOriginalUser: (state, action: PayloadAction<OriginalUserInterface | null>) => {
            state.originalUser = action.payload;
        },
    },
    extraReducers(builder) {
        builder
          .addMatcher(LoginAsPartnerApiSlice.endpoints.revertLoginAs.matchFulfilled, (state) => {
              state.originalUser = null;
          });
    }
});

export const {setOriginalUser} = LoginAsSlice.actions;

export const originalUserSelector = (state: RootState) => state.loginAs.originalUser;

export const LoginAsReducer = LoginAsSlice.reducer;
